import { dedupeArrayValues } from "owa-selected-calendars-utils";
import { trace } from "owa-trace";
import type { MailboxInfo } from "owa-client-types";
import { updateAccountScopeUserSettingsAndService } from "owa-userconfiguration/lib/utils/updateAccountScopeUserSettingsAndService";
import { isCapabilityEnabled } from "owa-capabilities";
import { mailboxCalendarModificationCapability } from "owa-capabilities-definitions/lib/mailboxCalendarModificationCapability";

export function updateSelectedCalendarsState(selectedCalendars: string[], mailboxInfo: MailboxInfo): void {
    if (selectedCalendars &&
        isCapabilityEnabled(mailboxCalendarModificationCapability, mailboxInfo)) {
        updateAccountScopeUserSettingsAndService(mailboxInfo, {
            ViewStateConfiguration: {
                SelectedCalendarsDesktop: dedupeArrayValues(selectedCalendars),
            },
        }).catch(() => {
            trace.warn("Could not save new selected calendars list to user configuration");
        });
    }
}
